import React from 'react';
import styles from '../../styles/pages/Editor.module.css';

const Question = () => {
  return (
    <div className={styles.left} style={{ paddingBottom: '80px' }}>
      <h2>Max Consecutive Ones</h2>
      <span>Easy</span>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Distinctio
        minima nihil beatae odio vitae! Maxime, expedita maiores. Quasi aliquam
        laborum excepturi amet ipsum ad aliquid voluptates natus, accusantium
        est nam perferendis iusto repellat impedit commodi alias eos fugiat
        dicta sequi modi! Ipsam at hic numquam nobis aspernatur magnam, minus
        recusandae.
      </p>
    </div>
  );
};

export default Question;
